import React from "react";
import { Outlet } from "react-router-dom";

const PartnerWrapper = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default PartnerWrapper;
